<template>
  <div id="main_wrapper" style="width: 1280px; margin: 8px auto 0px;">

    <!-- 顶部标题 -->
    <div class="header_wrapper">
      <div class="header_mark">
        <div class="title">                      
          <img src="@/assets/title.png" alt="Logo" class="title-image"/>
        </div>
        <div class="logo_group">
          <img src="@/assets/logo1.png" alt="Logo1" class="logo-image"/>
          <img src="@/assets/logo2.png" alt="Logo2" class="logo-image"/>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div style="position: relative; width:100%; ">
      <img src="@/assets/navigation.jpeg" style="width: 100%; display: block;">
      <div style="width: 100%;
       height: 100%; 
       position: absolute; 
       padding-left: 140px;
       top: 0px; 
       left: 0px; 
       line-height: 53px; 
       color: rgb(146, 104, 60); 
       font-weight: 600;
       font-family: 楷体, KaiTi, serif;
       text-align: left;
       "
       >
       <a href="/" style="margin-right: 36px; cursor: pointer; color: rgb(146, 104, 60); text-decoration: none; ">首页</a>
       <a href="/shuishu" style="margin-right: 36px; cursor: pointer; color: rgb(146, 104, 60); text-decoration: none; ">水书数据库检索</a>
       <a href="/ocr" style="margin-right: 36px; cursor: pointer; color: rgb(146, 104, 60); text-decoration: none; color: #771c1b">水书智能识别器</a>
      </div>
    </div>



    <div class="main_container batchocr">
      <!-- 核心部分 -->
      <div class="singleOCR_wrapper">
        <div class="singleOCR_container">
          <!-- 顶部按钮 -->
          <div class="container_top">
            <!-- 左边按钮 -->
            <div class="left">


              <img src="@/assets/upload_single.jpg" alt="上传单字" class="uploadSingleButtonImage" @click="handleSingleUpload"/>
              <input type="file" ref="singleFileInput" @change="uploadSingleImage" style="display: none;">

              <img src="@/assets/upload.jpg" alt="上传图片" class="uploadButtonImage" @click="handleUpload"/>
              <input type="file" ref="fileInput" @change="uploadImage" style="display: none;">       

              <img src="@/assets/recover.jpg" alt="一键复原" class="recoverButtonImage" @click="handleRecover"/>

              <div class="sample-links">
                <span @click="handleSample(1)" :class="{'sample-link': true, 'selected': selectedSample === 1 && isSampleActive}">样例一</span>
                <span @click="handleSample(2)" :class="{'sample-link': true, 'selected': selectedSample === 2 && isSampleActive}">样例二</span>
                <span @click="handleSample(3)" :class="{'sample-link': true, 'selected': selectedSample === 3 && isSampleActive}">样例三</span>
              </div>

            </div>
            <!-- 右边按钮 -->
            <div class="right">
             
              <img src="@/assets/download.jpg" alt="下载" class="downloadButtonImage" @click="downloadTxt"/>    
              <img src="@/assets/back.jpg" alt="返回首页" class="backButtonImage" @click="goHome"/>
            </div>
          </div>

          <!-- 显示 -->
          <div class="container_bottom el-row" element-loading-background="rgba(248,248,248,0.67)" element-loading-text="正在加载">
            <div class="content">          
              <!-- 左边原图 -->
              <div class="left">
                <div class="img" >
                  <div class="img-content scrollBar" ref="imgContent" id="three"  @wheel="handerPictu" @scroll="onLeftScroll">
                    <div class="img-scroll-area" :style="{ width: (imageNaturalWidth * imgScale) + 'px', height: (imageNaturalHeight * imgScale) + 'px' }">
                      <div class="img-wrapper" :style="{ transform: `scale(${imgScale})`, transformOrigin: '0 0', position: 'absolute' }">
                        <img :src="imageUrl" id="oImg" @load="onImageLoad" alt="" style="opacity: 1;"/>
                        <div v-for="box in boxes" 
                          :key="box.id" class="line-box" 
                          :class="{ active: box.id === activeBoxId }" 
                          :style="{
                            top: box.top + 'px', 
                            left: box.left + 'px', 
                            width: box.width + 'px', 
                            height: box.height + 'px',
                          }" 
                          @mouseenter="showBox(box.id)" 
                          @mouseleave="hideBox"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="img-bottom"></div>
                </div>
              </div>

              <!-- 右边结果 -->
              <div class="right">
                <div class="result">
                  <div id="four" class="result-content">
                    <div :class="['img-content', 'scrollBar', backgroundClass]" ref="resultContent" @wheel="handleResult" @scroll="onRightScroll">
                      <!-- 加载动画 -->
                      <div v-if="loading" class="loading-overlay">
                        <div style="position:fixed;left:0;top:0;display:flex;align-items: center;justify-content: center;;width:100%;height: 100%">
                          <div class="sk-chase">
                              <div class="sk-chase-dot"></div>
                              <div class="sk-chase-dot"></div>
                              <div class="sk-chase-dot"></div>
                              <div class="sk-chase-dot"></div>
                              <div class="sk-chase-dot"></div>
                              <div class="sk-chase-dot"></div>
                          </div>
                        </div>                                                       
                      </div>

                      <div class="guji" ref="gujiWrapper" :style="{width: gujiWidth + 'px', height: gujiHeight + 'px', transform: `scale(${gujiScale})`}">
                        <div v-for="box in boxes" 
                          :key="box.id" class="line-box" 
                          :class="{ active: box.id === activeBoxId }" 
                          :style="{
                            top: box.top + 'px', 
                            left: box.left + 'px', 
                            width: box.width + 'px', 
                            height: box.height + 'px'      
                          }" 
                          @mouseenter="showBox(box.id)" 
                          @mouseleave="hideBox"
                        >
                          <textarea 
                            v-model="box.text" 
                            class="text-line" 
                            :style="{
                              'font-size': Math.min(box.width, (box.height / box.text.length)) + 'px', 
                              'font-family': '楷体, bigFont1, bigFont3, bigFont2, bigFont4',
                              'height': '100%',
                              'width': '100%',       
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="result-content-right" style="float: right; width: 7%;">
                  <div class="changeBackground">
                    <div>背景</div>
                    <span class="ff" @click="changeBackground('ff')"></span>
                    <span class="e2" @click="changeBackground('e2')"></span>
                    <span class="db" @click="changeBackground('db')"></span>
                    <span class="f6" @click="changeBackground('f6')"></span>
                  </div>
                </div>
              </div>
            </div>       
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
  
<script>
import sampleLabels from '@/assets/sample_labels.json';

export default {
  name: 'MainComponent',
  data() {
    return {
      imageUrl: require('@/assets/sample1.jpg'),  // 默认样例
      selectedSample: 1, // 当前选中的样例
      isSampleActive: true, // 是否使用样例
      imgWidth: 'auto',  // 图片初始宽度
      imgHeight: 'auto',  // 图片初始高度
      imgScale: 1,  //图片的缩放比
      imageNaturalWidth: 1,
      imageNaturalHeight: 1,
      taskId: null,
      boxes: [], // 后端返回的文本框数据
      gujiWidth: 'auto', // guji默认样例宽度
      gujiHeight: 'auto', // guji默认样例高度
      gujiScale: 1,  // guji的缩放比
      activeBoxId: null, // 当前激活的文本框ID
      initialScale: 1, //初始的缩放比，调图片上的框用
      loading: false, // 结果loading状态
      keywords: [],
      backgroundClass: 'ff',
      pollingTimeout: null,
      pollingTimer: null,
      pollingActive: false,
      maxTaskDurationMs: 300000,
      syncingScroll: false
    };
  },
  mounted() {
    // 初始化显示样例一
    this.testBoundingBoxes1();
    this.imageUrl = require('@/assets/sample1.jpg'); 
    document.body.style.backgroundColor = "#f5f2ec";
  },
  methods: {
    // 滚轮等比放缩图片
    handerPictu(e) {
      this.handleCanvasWheel(e);
    },
    // 滚轮等比放缩结果 
    handleResult(e) {
      this.handleCanvasWheel(e);
    },
    shouldZoomEvent(e) {
      // Mac触摸板捏合通常会带ctrlKey；同时保留快捷键缩放能力
      return e.ctrlKey || e.metaKey;
    },
    handleCanvasWheel(e) {
      // 两指滑动默认走原生滚动，不拦截
      if (!this.shouldZoomEvent(e)) {
        return;
      }
      // 只有缩放手势时才阻止默认滚动
      e.preventDefault();
      this.applyZoom(e);
    },
    applyZoom(e) {
      if (e.deltaY > 0) {
        this.imgScale = Math.max(this.imgScale - 0.1, 0.1);
      } else {
        this.imgScale += 0.1;
      }
      this.gujiScale = this.imgScale;
      console.log("同步放缩大小: " + this.imgScale);
    },
    syncScrollPosition(source, target) {
      if (!source || !target) return;

      const maxSourceLeft = Math.max(source.scrollWidth - source.clientWidth, 0);
      const maxSourceTop = Math.max(source.scrollHeight - source.clientHeight, 0);
      const maxTargetLeft = Math.max(target.scrollWidth - target.clientWidth, 0);
      const maxTargetTop = Math.max(target.scrollHeight - target.clientHeight, 0);

      const leftRatio = maxSourceLeft > 0 ? source.scrollLeft / maxSourceLeft : 0;
      const topRatio = maxSourceTop > 0 ? source.scrollTop / maxSourceTop : 0;

      target.scrollLeft = leftRatio * maxTargetLeft;
      target.scrollTop = topRatio * maxTargetTop;
    },
    onLeftScroll() {
      if (this.syncingScroll) return;
      this.syncingScroll = true;
      this.syncScrollPosition(this.$refs.imgContent, this.$refs.resultContent);
      this.$nextTick(() => {
        this.syncingScroll = false;
      });
    },
    onRightScroll() {
      if (this.syncingScroll) return;
      this.syncingScroll = true;
      this.syncScrollPosition(this.$refs.resultContent, this.$refs.imgContent);
      this.$nextTick(() => {
        this.syncingScroll = false;
      });
    },
    handleUpload() {
      this.stopPolling(true);
      this.$refs.fileInput.click();
      this.clearResults();
      this.isSampleActive = false; // 停止使用样例
      this.selectedSample = null; // 取消样例选中状态
    },

    handleSingleUpload(){
      this.stopPolling(true);
      this.$refs.singleFileInput.click();
      this.clearResults();
      this.isSampleActive = false; // 停止使用样例
      this.selectedSample = null; // 取消样例选中状态
    },
    // 清空右边结果区域
    clearResults() {
      this.imageUrl = '';
      this.boxes = [];
      this.gujiWidth = 1310;
      this.gujiHeight = 2312;
      this.gujiScale = 1;
      this.backgroundClass = 'ff';
    },
    goHome() {
      window.location.href = 'https://ocr.ihanzi.net/';
    },



    // 向后端发送图片
    async uploadImage(event) {
      const file = event.target.files[0];
      // 空文件
      if (!file) {
        alert('请选择一个有效的文件');
        return;
      }
      // 非图片文件
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!validImageTypes.includes(file.type)) {
        alert('请选择一个有效的图片文件 (JPEG, PNG, GIF)');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      this.imageUrl = URL.createObjectURL(file);
      this.loading = true; // 开始加载

      try {
        const response = await fetch('https://ocr.ihanzi.net/shui_ocr_api/upload', {
          method: 'POST',
          body: formData,
        });
        if(!response.ok){
          throw new Error(`上传失败: ${response.status} ${response.statusText}`);
        }
        const result = await response.json();
        this.taskId = result.taskId;
        this.startPolling(); // 开始轮询
      } catch (error) {
        this.loading=false;
        alert('上传图片时出错，请重试');
      }
    },
     // 向后端发送单字图片
    async uploadSingleImage(event) {
      const file = event.target.files[0];
      if (!file) {
        alert('请选择一个有效的文件');
        return;
      }
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!validImageTypes.includes(file.type)) {
        alert('请选择一个有效的图片文件 (JPEG, PNG, GIF)');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      this.imageUrl = URL.createObjectURL(file);
      this.loading = true; // 开始加载

      try {
        const response = await fetch('https://ocr.ihanzi.net/shui_ocr_api/upload_single', {
          method: 'POST',
          body: formData,
        });
        if (!response.ok) {
          throw new Error(`上传失败: ${response.status} ${response.statusText}`);
        }
        const result = await response.json();
        this.taskId = result.taskId;
        this.startPolling(); // 开始轮询获取识别结果
      } catch (error) {
        this.loading = false;
        alert('上传单字图片时出错，请重试');
      }
    },
    // 启动轮询
    startPolling() {
      this.stopPolling();
      this.pollingStartTime = Date.now();
      this.pollingActive = true;
      this.pollingTimeout = setTimeout(() => {
        this.stopPolling();
        this.loading = false; // 停止加载
        alert('生成结果超时，请重试');
      }, this.maxTaskDurationMs); // 单任务上限5分钟

      this.pollTaskStatus();
    },

    stopPolling(resetTaskId = false) {
      this.pollingActive = false;
      if (this.pollingTimeout) {
        clearTimeout(this.pollingTimeout);
        this.pollingTimeout = null;
      }
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
      if (resetTaskId) {
        this.taskId = null;
      }
    },

    // 验证后端返回的数据格式
    validateResultFormat(result) {
      if (typeof result !== 'object') return false;
      if (typeof result.taskId !== 'string') return false;
      if (result.status !== 'completed') return false;
      if (typeof result.gujiHeight !== 'number') return false;
      if (typeof result.gujiWidth !== 'number') return false;
      if (!Array.isArray(result.boxes)) return false;
      if (!Array.isArray(result.txts)) return false;
      for (const box of result.boxes) {
        if (!Array.isArray(box)) return false;
        for (const point of box) {
          if (!Array.isArray(point) || point.length !== 2) return false;
          if (typeof point[0] !== 'number' || typeof point[1] !== 'number') return false;
        }
      }
      for (const txt of result.txts) {
        if (typeof txt !== 'string') return false;
      }
      return true;
    },

    // 异步查询后端返回结果
    async pollTaskStatus() {
      if (!this.taskId || !this.pollingActive) return;
      try {
        const response = await fetch(`https://ocr.ihanzi.net/shui_ocr_api/result/${this.taskId}`);
        if (!this.pollingActive) return;
        const result = await response.json();
        if (!this.pollingActive) return;

        if (result.status === 'completed') {
          if(this.validateResultFormat(result)){
            this.stopPolling();

            await this.sendAccepted();  // 发送Accepted请求
            // 获得数据
            this.boxes = result.boxes;
            this.loading = false; // 停止加载
            console.log("已获得数据")
            this.gujiHeight = result.gujiHeight;
            this.gujiWeight = result.gujiWeight;
            this.drawBoundingBoxes(result.boxes, result.txts);
            console.log("taskid"+result.taskId);
          }else{
            throw new Error('非法数据格式');
          }    
        } else {
          console.log("未获得数据")
          if (this.pollingActive) {
            this.pollingTimer = setTimeout(() => this.pollTaskStatus(), 2000);
          }
        }
      } catch (error) {
        console.error('Error polling task status:', error);
        this.loading = false; // 停止加载
        this.stopPolling();
        alert('识别接口调用失败，请联系管理员');
      }
    },
    // 发送Accepted和任务id
    async sendAccepted() {
      try {
        const response = await fetch('https://ocr.ihanzi.net/shui_ocr_api/ack', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            status: 'Accepted',
            taskId: this.taskId
          }),
        });
        if (!response.ok) {
          throw new Error('Failed to send accepted status');
        } 
        console.log("已发送Accepted");
      } catch (error) {
        console.error('Error sending accepted status:', error);
      }
    },
    // 加载图片
    onImageLoad() {
      const img = document.getElementById("oImg");
      this.imageNaturalWidth = img.naturalWidth || 1;
      this.imageNaturalHeight = img.naturalHeight || 1;
      this.gujiHeight = img.naturalheight;
      this.gujiWidth = img.naturalWidthidth;
      const container = this.$refs.imgContent;

      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;

      const WidthScale = containerWidth / img.naturalWidth;
      const HeightScale = containerHeight / img.naturalHeight;

      if(WidthScale > HeightScale){ //图片的高是影响因素
        this.imgScale = HeightScale;
      }else{  //图片的宽是影响因素
        this.imgScale = WidthScale;
      }
      this.gujiScale = this.imgScale;
      this.initialScale = this.imgScale;

      console.log("容器Width"+containerWidth);
      console.log("容器高Height"+containerHeight);
      console.log("WidthScale"+WidthScale);
      console.log("HeightScale"+HeightScale);
      console.log("初始缩放比例"+this.initialScale);
    },
    handleRecover(){
      this.imgScale = this.initialScale;
      this.gujiScale = this.initialScale;
      this.backgroundClass = '.ff';
    },
    // 显示结果
    drawBoundingBoxes(boxes, txts) {
      this.boxes = boxes.map((box, index) => ({
        id: index,
        top: box[0][1],
        left: box[0][0],
        width: Math.abs(box[0][0] - box[2][0]),
        height: Math.abs(box[0][1] - box[2][1]),
        text: txts[index],
        left_top_0: box[0][0],
        left_top_1: box[0][1],
        right_top_0: box[1][0],
        right_top_1: box[1][1],
        right_down_0: box[2][0],
        right_down_1: box[2][1],
        left_down_0: box[3][0],
        left_down_1: box[3][1],
      }));
    },

    showBox(id) {
      this.activeBoxId = id;
    },
    hideBox() {
      this.activeBoxId = null;
    },

    changeBackground(className) {
      this.backgroundClass = className;
    },

    // 下载文本文件
    downloadTxt() {
      const data = {
        gujiWidth: this.gujiWidth,
        gujiHeight: this.gujiHeight,
        boxes: this.boxes.map(box => [
          [box.left_top_0, box.left_top_1],
          [box.right_top_0, box.right_top_1],
          [box.right_down_0, box.right_down_1],
          [box.left_down_0, box.left_down_1]
        ]),
        txts: this.boxes.map(box => box.text)
      };
      const blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'data.txt';
      link.click();
    },

    //选择样例
    handleSample(sampleNumber) {
      this.selectedSample = sampleNumber;
      this.isSampleActive = true;
      if (sampleNumber === 1) {
        this.imageUrl = require('@/assets/sample1.jpg');
        this.testBoundingBoxes1();
      } else if (sampleNumber === 2) {
        this.imageUrl = require('@/assets/4507.jpg');
        this.testBoundingBoxes2();
      } else if (sampleNumber === 3) {
        this.imageUrl = require('@/assets/4744.jpg'); 
        this.testBoundingBoxes3();
      }
      console.log("选中样例"+sampleNumber);
    },
    applyLabelSample(sampleKey) {
      const sample = sampleLabels[sampleKey];
      if (!sample || !Array.isArray(sample.boxes) || !Array.isArray(sample.txts)) {
        this.drawBoundingBoxes([], []);
        return;
      }

      const filteredBoxes = [];
      const filteredTxts = [];

      sample.boxes.forEach((box, idx) => {
        const txt = typeof sample.txts[idx] === 'string' ? sample.txts[idx].trim() : '';
        if (!txt || txt === '待识别') {
          return;
        }
        filteredBoxes.push(box);
        filteredTxts.push(txt);
      });

      this.drawBoundingBoxes(filteredBoxes, filteredTxts);
    },
    // 测试文本显示
    testBoundingBoxes1() {
      const testData = {
        status: 'completed',
        gujiWidth: 1951, 
        gujiHeight: 2528,
        boxes: [
          [[1715, 302], [1853, 301], [1858, 1304], [1721, 1305]],
          [[1411, 194], [1562, 197], [1526, 2310], [1375, 2308]],
          [[1104, 294], [1268, 297], [1245, 1628], [1081, 1625]],
          [[732, 160], [920, 162], [898, 2360], [710, 2358]],
          [[402, 302], [644, 283], [606, 1583], [379, 1594]],
          [[125, 148], [337, 140], [344, 2467], [133, 2448]]
        ],
        txts: [
          "五十一月凶四十二月凶",
          "寅申年六十二大吉正七小吉二八月凶",
          "三九凶四十月凶五十一月凶",
          "巳亥年正七大吉六十二小吉五十一月凶",
          "四十三九月凶二八月凶",
          "卯酉年四十月大吉五十一小吉二八月凶"
        ]
      };
      this.drawBoundingBoxes(testData.boxes, testData.txts);
    },
    testBoundingBoxes2() {
      this.applyLabelSample('4507');
    },
    testBoundingBoxes3() {
      this.applyLabelSample('4744');
    },
  }
};
</script>
  
<style scoped>

body, html {
  background: #f5f2ec;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  margin: 0;
  padding: 0;
}
.sk-chase {
  width: 40px;
  height: 40px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0; 
  animation: sk-chase-dot 2.0s infinite ease-in-out both; 
}

.sk-chase-dot:before {
  content: '';
  display: block;
  width: 25%;
  height: 25%;
  background-color: #606266;
  border-radius: 100%;
  animation: sk-chase-dot-before 2.0s infinite ease-in-out both; 
}

.sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
.sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
.sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
.sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
.sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
.sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
.sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
.sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
.sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
.sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
.sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
.sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

@keyframes sk-chase {
  100% { transform: rotate(360deg); } 
}

@keyframes sk-chase-dot {
  80%, 100% { transform: rotate(360deg); } 
}

@keyframes sk-chase-dot-before {
  50% {
    transform: scale(0.4); 
  } 100%, 0% {
    transform: scale(1.0); 
  } 
}

#main_wrapper {
  overflow: hidden;
}


.header_wrapper .header_mark {
  width: 100%;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-right: 50px;
  margin-top: 0px;
  height: 50px;
}

.header_wrapper, .header_wrapper .header_mark {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.header_wrapper .header_mark .logo_group {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.header_wrapper .header_mark .logo_group .logo-image {
  position: relative;
  width: 50px;
  height: 50px;
}

.header_wrapper .header_mark .title .title-image {
  position: relative;
  margin-left: 10px;
  width: 320px;
  height: 50px;
}

.header_wrapper {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  min-width: 1050px;
  padding: 0 50px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  z-index: 99;
}

#main_wrapper .main_container {
  width: 90%;
  min-width: 1050px;
  margin: 24px auto 0;
  margin-top: 0px;
  min-height: calc(100vh - 279px);
  padding: 0 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.singleOCR_wrapper .singleOCR_container .container_top {
  height: 60px;
  width: 96%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-line-pack: center;
  align-content: center;
  margin: 0 2%;
  margin-top: 5px;
  margin-bottom: 5px;
}
.singleOCR_wrapper .singleOCR_container .container_top .left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.singleOCR_wrapper .singleOCR_container .container_top .left .uploadSingleButtonImage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 130px;
  height: 35px;
}

.singleOCR_wrapper .singleOCR_container .container_top .left .uploadButtonImage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 130px;
  height: 35px;
  margin-left: 20px;
}

.singleOCR_wrapper .singleOCR_container .container_top .left .recoverButtonImage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 130px;
  height: 35px;
  margin-left: 20px;

}

.singleOCR_wrapper .singleOCR_container .container_top .left .sample-link{
  margin-left: 30px;
  font-family: Cursive;
  color: rgb(146, 104, 60);
  font-weight: 600;
}

.sample-link.selected {
  color: #771c1b !important;
}

.sample-link:hover {
  text-decoration: underline;
}

.singleOCR_wrapper .singleOCR_container .container_top .right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.singleOCR_wrapper .singleOCR_container .container_top .right .downloadButtonImage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  overflow: hidden;
  width: 130px;
  height: 35px;
}

.singleOCR_wrapper .singleOCR_container .container_top .right .backButtonImage {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  overflow: hidden;
  width: 130px;
  height: 35px;
}

.singleOCR_wrapper .singleOCR_container .container_bottom {
  height: calc(100vh - 229px);
  min-height: 600px;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content {
  width: 96%;
  height: 100%;
  margin: 0 2%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-self: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .left {
  width: 49%;
  height: 100%;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .left .img {
  width: 100%;
  height: 100%;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .left .img .img-content {
  width: 100%;
  border: 1px solid #c6c4c4;
  height: 92.6%;
  background-color: #fff;
  box-sizing: border-box;
  overflow-x: scroll;
  overflow-y: scroll;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .left .img .img-content .img-scroll-area {
  position: relative;
  min-width: 100%;
  min-height: 100%;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right {
  width: 49%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result {
  width: 93%;
  height: 100%;
  float: left;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result .result-content {
  width: 100%;
  height: 92.3%;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result .result-content .img-content {
  overflow: auto;
  width: 100%;
  height: 100%;
  border: 1px solid #c6c4c4;

  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result .result-content .img-content .guji {
  transform-origin: 0px 0px; 
  position: absolute; 
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result .result-content .img-content .guji .line-box {
  position: absolute;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
}

.active{
  position: absolute;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;

  border: 2px solid red;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .left .img .img-content .img-wrapper .line-box{
  position: absolute;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result .result-content .img-content .guji .line-box .text-line {
  writing-mode: vertical-rl; /* 竖排文本 */
  text-orientation: upright; /* 文字直立 */
  display: flex;

  padding: 0;
  margin: 0;
  box-sizing: border-box;
  resize: none;
  background: transparent;
  border: none;
  outline: none;
  overflow: hidden;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  z-index: 1000;
}

element.style {
  float: right;
  width: 7%;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-right: 0;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground {
  margin-left: 11px;
  margin-top: 20px;
  width: 32px;
}

.img-content.ff {
  background-color: #fff;
}
.img-content.e2 {
  background-color: #e2ecca;
}
.img-content.db {
  background-color: #dbe1f1;
}
.img-content.f6 {
  background-color: #f6eee6;
}

.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground span {
  display: block;
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
  margin-top: 10px;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground .ff {
  background-color: #fff;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground .e2 {
  background-color: #e2ecca;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground .db {
  background-color: #dbe1f1;
}
.singleOCR_wrapper .singleOCR_container .container_bottom .content .right .result-content-right .changeBackground .f6 {
  background-color: #f6eee6;
}

</style>
  